/** Dialog for editing some VJT properties. */

import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    Input,
    InputLabel,
    MenuItem,
    Select
} from "@material-ui/core";
import {ChangeEvent, useEffect, useState} from "react";
import {Alert, AlertTitle} from "@material-ui/lab";
import {Cancel, Save} from "@material-ui/icons";
import {objectToFormData} from "../../../../web-services/utils/object-to-form-data";
import {IParkingLotEditDialogProps} from "./props";
import "./parking-lot-edit-dialog.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ParkingLotEditDialog(props: IParkingLotEditDialogProps) {
    const [errorMsg, setErrorMsg] = useState<string | undefined>();
    const [errorCategoryMsg, setErrorCategoryMessage] = useState<string | undefined>();
    const [isRequestSending, setIsRequestSending] = useState<boolean | undefined>();

    const [id, setId] = useState(props.parkingLot?.allPlaces);
    const [szabadParkolok, setszabadParkolok] = useState(props.parkingLot?.cars);

    useEffect(() => {
        setId(props.parkingLot?.allPlaces);
        setszabadParkolok(props.parkingLot?.cars);
        console.log("Opened: " + props.open);

        if (!props.parkingLot) setErrorMsg("Nincs Parkinglot átadva szerkesztésre. Kérjük, nyissa meg újra a dialógust.");
        else setErrorMsg(undefined);
    }, [props.parkingLot]);

    useEffect(() =>
    {
        if (!isRequestSending) return;

        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            try
            {
                await props.httpClient.post(
                    "values/post-freeplaces-update",
                    "",
                    objectToFormData({
                        parkingLotId: props.parkingLotId,
                        freePlaces: szabadParkolok
                    }),
                    15000
                );
                setIsRequestSending(false);
                props.onSaveSuccess();
            }
            catch (err: any)
            {
                setIsRequestSending(false);
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorMsg("Kérjük, próbálja újra a mentést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    }, [isRequestSending]);
    const renderAlert = (errorText: string | undefined, errorCategoryText: string | undefined) => (
        errorText
            ? (
                <Grid item xs={12}>
                    <Alert severity="error" className="parking-lot-edit-error">{errorCategoryText
                        ? <AlertTitle>{errorCategoryText}</AlertTitle> : undefined}{errorText}
                    </Alert>
                </Grid>
            )
            : undefined
    );

    const renderCircularProgress = () => (
        isRequestSending
            ? <Grid item xs={12}>
                <div className="circular-progress-container"><CircularProgress size={24}/></div>
            </Grid>
            : undefined
    );

    const renderDialogActions = () => {
        let buttons = [
            <Button
                key={0}
                startIcon={<Cancel/>}
                variant="contained"
                color="secondary"
                onClick={props.onClose}
            >
                {id ? "Mégsem" : "Bezárás"}
            </Button>
        ];
        if (id) {
            buttons.push(
                <Button
                    key={1}
                    startIcon={<Save/>}
                    variant="contained"
                    disabled={isRequestSending}
                    color="primary"
                    onClick={() => setIsRequestSending(true)}
                    autoFocus
                >
                    Mentés
                </Button>
            );
        }

        return buttons;
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value, 10); // Convert the input value to a number
        setszabadParkolok(isNaN(newValue) ? undefined : newValue); // Update state with the number or undefined if the conversion fails
    };
    const renderSzabadHelyekSzama = () => (
        <Grid item xs={12} key={0}>
            <FormControl variant="standard" className="wide-field">
                <InputLabel>Jelenlegi szabad helyek száma</InputLabel>
                <Input
                    value={szabadParkolok}
                    onChange={handleInputChange}
                />
            </FormControl>
        </Grid>
    );

return (
    <Dialog open={props.open || false}>
        <DialogTitle>Szabad helyek számának módosítása</DialogTitle>
        <DialogContent>
            <Grid container spacing={2}>
                {renderSzabadHelyekSzama()}
                {renderCircularProgress()}
                {renderAlert(errorMsg, errorCategoryMsg)}
            </Grid>
        </DialogContent>
        <DialogActions>
            {renderDialogActions()}
        </DialogActions>
    </Dialog>
);
}
